require('./brokerCustomWalletEditablePortfolio.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');

// @ commons
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { InputSafe } = require('commonsComponents/inputSafe');
const { OKLink } = require('commonsComponents/OKLink');
const { OKIconButton } = require('commonsComponents/OKIconButton');
const { OKButton } = require('components/commons/OKButton/OKButton');

const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');

// @ components
const BrokerCustomWalletGroupedPortfolios = require('../brokerCustomWalletGroupedPortfolios/brokerCustomWalletGroupedPortfolios');
const BrokerCustomWalletPortfolioEmptyState = require('../brokerCustomWalletPortfolioEmptyState/brokerCustomWalletPortfolioEmptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ utils
const { formatText, FormattedText } = require('core/i18n').i18n;
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const WebappRender = require('components/conditionalRender/webappRender')

// @ constants
const {
    BROKER_CUSTOM_WALLET_CREATE_INPUT_LIMIT,
    BROKER_PG_URL,
    MYPROFILE_BROKER_EXPLORE_URL,
    BROKER_CUSTOM_WALLET_CONTRACT_NONE,
    BROKER_CUSTOM_WALLET_CONTRACT_ERROR
} = require('../../constants/index');

class BrokerCustomWalletEditablePortfolio extends React.Component {
    constructor(props) {
        super(props);
        this.handleChangeName = this.handleChangeName.bind(this);
        this.handleSwitchItemContract = this.handleSwitchItemContract.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleChangeSetDefaultView = this.handleChangeSetDefaultView.bind(this);
    }

    getCustomTooltip() {
        const tooltipContent = formatText('brokerCustomWallet-nameTooltipContent');
        const lines = tooltipContent.split('\n');

        return (
            <OKTooltip
                content={<div> {lines.map((line) => <p key={line}>{line}</p>)} </div>}
                offset={[0,-10]}
            />
        );
    }

    getErrorMessage(repeatedName) {
        const emptyErrorMsg = formatText('brokerCustomWallet-emptyErrorMsg');
        const repeatedErrorMsg = formatText('brokerCustomWallet-repeatedErrorMsg');

        return repeatedName ? repeatedErrorMsg : emptyErrorMsg;
    }

    buildContractName() {
        const { immBrokerCustomWalletEditablePortfolio, actionsAvailable, creatingNew } = this.props;
        const viewName = immBrokerCustomWalletEditablePortfolio.get('viewName');
        const viewNameErrorState = immBrokerCustomWalletEditablePortfolio.getIn(['validation','showViewNameErrors']);
        const repeatedName = immBrokerCustomWalletEditablePortfolio.getIn(['validation', 'repeatedName']);
        const placeholder = formatText('brokerCustomWallet-createViewPlaceHolder');
        const errorMessage = this.getErrorMessage(repeatedName);
        const disabled = creatingNew ? false : !actionsAvailable;

        if (creatingNew && viewNameErrorState){
            scrollToTop();
        }

        return (
            <fieldset className="custom-wallet-editable-portfolio__name custom-wallet-editable-portfolio__input" allowOnClick={false}>
                <InputSafe
                    autoComplete={false}
                    value={viewName}
                    placeholder={placeholder}
                    onChange={this.handleChangeName}
                    maxLength={BROKER_CUSTOM_WALLET_CREATE_INPUT_LIMIT}
                    errorState={viewNameErrorState}
                    errorMessage={errorMessage}
                    disabled={disabled}/>
            </fieldset>
        );
    }

    buildActionsButton() {
        if (this.props.actionsAvailable) {
            const { immBrokerCustomWalletEditablePortfolio } = this.props;
            const idPortfolioAccount = immBrokerCustomWalletEditablePortfolio.get('idPortfolioAccount');
            const name = immBrokerCustomWalletEditablePortfolio.get('viewName');

            const handleOnClickDelete = () => {
                this.handleDelete(idPortfolioAccount, name);
            };

            return (
                <div className="custom-wallet-editable-portfolio__button-group">
                    <span>
                        <OKIconButton
                            size="small"
                            icon="icon-eliminar"
                            onClick={handleOnClickDelete}
                        />
                    </span>
                </div>
            );
        }
    }

    buildCheckbox() {
        const { defaultViewAvailable, immBrokerCustomWalletEditablePortfolio } = this.props;
        const setDefaultOnCreate = immBrokerCustomWalletEditablePortfolio.get('setDefaultOnCreate');

        if (defaultViewAvailable) {
            return (
                <WebappRender>
                    <div className="custom-wallet-editable-portfolio__check--default">
                        <OKCheckbox
                            idName="setDefaulViewCheck"
                            label={formatText('brokerCustomWallet-checkDefaultViewOnCreate')}
                            value={setDefaultOnCreate}
                            onChange={this.handleChangeSetDefaultView}
                        />
                    </div>
                </WebappRender>
            );
        }
    }

    buildContractList() {
        const {
            immBrokerCustomWalletEditablePortfolio,
            immBrokerCustomWalletInterveners,
            enableAllPortfolioContractsByType,
            disableAllPortfolioContractsByType,
            idPortfolioAccount,
            immPortfolio,
            creatingNew
        } = this.props;

        let mappedContracts = <LoadingSection />;
        const contracts = immBrokerCustomWalletEditablePortfolio.get('contracts');
        const intervenersByContractId = immBrokerCustomWalletInterveners.get('contractsIntervention');
        const editingError = immPortfolio ? immPortfolio.get('isCustomWalletContractRequestError') : false;
        const noContracts = contracts.size == 0 && immBrokerCustomWalletEditablePortfolio.getIn(['contractRequest','success']);

        if (!creatingNew && editingError || noContracts) {
            mappedContracts = <BrokerCustomWalletPortfolioEmptyState onLeaveAction={this.props.handleCancelClick}/>;
        } else if (contracts.size > 0 && immBrokerCustomWalletEditablePortfolio.get('idPortfolioAccount') === idPortfolioAccount
            || contracts.size > 0 && creatingNew) {
            mappedContracts = (
                <BrokerCustomWalletGroupedPortfolios
                    immContracts={contracts}
                    immIntervenersByContractId={intervenersByContractId}
                    onSwitchChange={this.handleSwitchItemContract}
                    onGroupToggleOn={enableAllPortfolioContractsByType}
                    onGroupToggleOff={disableAllPortfolioContractsByType}
                    editable={true}
                    creatingNew={creatingNew}
                />
            );
        }

        return (
            <div className="custom-wallet-editable-portfolio__item-list">
                {mappedContracts}
            </div>
        );
    }

    buildEmptyState(type) {
        if (type === BROKER_CUSTOM_WALLET_CONTRACT_ERROR) {
            return (
                <div className="custom-wallet-editable-portfolio__empty-state">
                    <BrokerCustomWalletPortfolioEmptyState />
                    <OKLink
                        modifier="complementary"
                        to={BROKER_PG_URL}
                    >
                        <FormattedText value="broker-errorGoToMyWallet" />
                    </OKLink>
                </div>
            );
        } else if (type === BROKER_CUSTOM_WALLET_CONTRACT_NONE) {
            return (
                <div className="custom-wallet-editable-portfolio__empty-state">
                    <BrokerCustomWalletPortfolioEmptyState isEmptyState={true} />
                    <OKButton
                        modifier="secondary"
                        to={MYPROFILE_BROKER_EXPLORE_URL}
                    >
                        <FormattedText value="brokerCustomWallet-contractEmptyStateLink"/>
                    </OKButton>
                </div>
            );
        }
    }

    buildFooter() {
        const { immBrokerCustomWalletEditablePortfolio } = this.props;
        const { creatingNew } = this.props;
        const contracts = immBrokerCustomWalletEditablePortfolio.get('contracts');
        let optionalCancelButton = null;
        let optionalSaveButton = null;
        const saveText = creatingNew ? <FormattedText value="brokerCustomWallet-createButton" /> : <FormattedText value="brokerCustomWallet-saveChangesButton" />;

        if (contracts.size > 0) {
            optionalSaveButton = (
                <WebappRender>
                    <div className="col-xs-6 text-right">
                        <OKButton modifier="secondary" onClick={this.handleSave}>
                            {saveText}
                        </OKButton>
                    </div>
                </WebappRender>
            );
        }

        if (contracts.size > 0 || creatingNew) {
            optionalCancelButton = (<div className="col-xs-6">
                <OKButton
                    modifier="link-ghost"
                    onClick={this.props.handleCancelClick}
                >
                    <FormattedText value="brokerCustomWallet-CancelButton" />
                </OKButton>
            </div>)
        }

        if (!optionalCancelButton && !optionalSaveButton) {
            return null;
        }
        else {
            return (
                <footer className="custom-wallet-editable-portfolio__footer">
                    {optionalCancelButton}
                    {optionalSaveButton}
                </footer>
            )
        }
    }

    handleChangeName(event) {
        this.props.inputNameChange(event.target.value);
    }

    handleChangeSetDefaultView(evt) {
        this.props.setDefaultViewOnCreate(evt.target.checked);
    }

    handleDelete(idPortfolioAccount, name) {
        const { immPortfolio } = this.props;
        const isOnEditionMode = immPortfolio && immPortfolio.get('editionMode');
        this.props.setPortfolioToDelete(idPortfolioAccount, name, isOnEditionMode);
    }

    handleSave() {
        const { saveCallbacks } = this.props;

        this.props.savePortfolio(saveCallbacks);
    }

    handleSwitchItemContract(contractNumber) {
        this.props.changeSwitchItemContract(contractNumber);
    }

    render() {
        const { immBrokerCustomWalletEditablePortfolio } = this.props;
        const idPortfolioAccount = immBrokerCustomWalletEditablePortfolio.get('idPortfolioAccount');
        const showAtLeastOneContractError = immBrokerCustomWalletEditablePortfolio.getIn(['validation', 'showAtLeastOneContractError']);

        let contractsDisable;
        if (showAtLeastOneContractError) {
            contractsDisable = formatText('brokerCustomWallet-contractsDisable');
        }

        return (
            <Accordion
                customClassName="custom-wallet-editable-portfolio"
                isExpanded={true}>
                <AccordionHeader name="AccordionHeader">
                    <div className="custom-wallet-editable-portfolio__header-container">
                        <div className="custom-wallet-editable-portfolio__header-container-left">
                            {this.buildContractName()}
                            {this.getCustomTooltip()}
                        </div>
                        <div>
                            {this.buildActionsButton(idPortfolioAccount)}
                        </div>
                    </div>
                </AccordionHeader>
                <AccordionBody name="AccordionBody">
                    {this.buildContractList()}
                    <div className="custom-wallet-editable-portfolio__contracts-disable-error">
                        {contractsDisable}
                    </div>
                    {this.buildCheckbox()}
                    {this.buildFooter()}
                </AccordionBody>
            </Accordion>
        );
    }
}

BrokerCustomWalletEditablePortfolio.propTypes = {
    immBrokerCustomWalletEditablePortfolio: PropTypes.any.isRequired,
    immBrokerCustomWalletInterveners: PropTypes.object.isRequired,
    immPortfolio: PropTypes.any,
    idPortfolioAccount: PropTypes.number,
    actionsAvailable: PropTypes.bool.isRequired,
    setPortfolioToDelete: PropTypes.func.isRequired,
    inputNameChange: PropTypes.func.isRequired,
    changeSwitchItemContract: PropTypes.func,
    handleCancelClick: PropTypes.func,
    saveCallbacks: PropTypes.any.isRequired,
    savePortfolio: PropTypes.func.isRequired,
    creatingNew: PropTypes.bool,
    enableAllPortfolioContractsByType: PropTypes.func.isRequired,
    disableAllPortfolioContractsByType: PropTypes.func.isRequired,
    setDefaultViewOnCreate: PropTypes.func.isRequired,
    defaultViewAvailable: PropTypes.bool.isRequired,
    loadEditablePortfolioById: PropTypes.func,
    getDetailsByPortfolio: PropTypes.func.isRequired
};

BrokerCustomWalletEditablePortfolio.defaultProps = {
    defaultViewAvailable: false,
    creatingNew: false
};

module.exports = BrokerCustomWalletEditablePortfolio;
